export const isDebugDev =
  typeof window !== 'undefined' &&
  (() => {
    try {
      return window.localStorage.getItem('debugDev') === 'ken'
    } catch {
      return false
    }
  })()

/** When debugDev is "ken", ensures the given promise takes at least minMs. Use to make loading steps visible for debugging. */
export function withDebugDelay<T>(label: string, minMs: number, fn: () => Promise<T>): Promise<T> {
  if (!isDebugDev) {
    return fn()
  }
  return Promise.all([fn(), new Promise<void>(r => setTimeout(r, minMs))]).then(([result]) => result as T)
}
